import { BLOTOUT_LOCALE_MAP } from '@portal/config/base';
import { StoreCode } from '@portal/schema/storeCode';
import { LocaleEnum } from '@portal/schema/locale';
import Script from 'next/script';

interface BlotoutScriptProps {
  store: StoreCode;
  locale: LocaleEnum;
}

export const BlotoutScript = ({ store, locale }: BlotoutScriptProps) => {
  if (!store) return null;

  const edgeURL = BLOTOUT_LOCALE_MAP[locale];

  return (
    <>
      <Script id="edgetag-init" strategy="afterInteractive">
        {`window.edgetag=window.edgetag||function(){(edgetag.stubs=edgetag.stubs||[]).push(arguments)};
          window.is_${store}_store = true;
          if("${locale}" === 'apac-us') {
            window.is_roa_locale = true;
          }
          edgetag('init', {
            edgeURL: '${edgeURL}',
            disableConsentCheck: true
          });`}
      </Script>
      <Script
        strategy="afterInteractive"
        src={`${edgeURL}/load`}
        onError={(e) => {
          // eslint-disable-next-line no-console
          console.error('Edgetag failed to load', e);
        }}
      />
    </>
  );
};
